<template>
    <div class='top-list'>
      <div class="contentBox">

        <div class="titleBox">{{detail.title}}</div>
        <div class="pd25">
          <div style="border-bottom: 2px solid #DDDDDD;padding-bottom: 10px;">
            <div class="dateBox">
              发布时间：{{detail.release}}
            </div>
          </div>
        </div>

        <div class="contentDetail">
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">标准状态</div>
                <div class="contentDetailBoxRight">{{detail.status==1?'现行':''}}</div>
            </div>
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">标准编号</div>
                <div class="contentDetailBoxRight">{{detail.ref}}</div>
            </div>
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">中文标题</div>
                <div class="contentDetailBoxRight">{{detail.title}}</div>
            </div>
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">英文标题</div>
                <div class="contentDetailBoxRight">{{detail.title_en}}</div>
            </div>
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">国际标准分类号</div>
                <div class="contentDetailBoxRight">{{detail.num}}</div>
            </div>
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">中国标准分类号</div>
                <div class="contentDetailBoxRight">{{detail.num_zn}}</div>
            </div>
            <!-- <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">国民经济分类</div>
                <div class="contentDetailBoxRight">{{detail.type}}</div>
            </div> -->


            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">发布日期</div>
                <div class="contentDetailBoxRight">{{detail.release}}</div>
            </div>
            <div  class="contentDetailBox">
                <div class="contentDetailBoxLeft">实施日期</div>
                <div class="contentDetailBoxRight">{{detail.start}}</div>
            </div>
            <div  class="contentDetailBox inlineBox">
                <div class="contentDetailBoxLeft">起草人</div>
                <div class="contentDetailBoxRight mobileFont">{{detail.drafter}}</div>
            </div>
            <div  class="contentDetailBox inlineBox">
                <div class="contentDetailBoxLeft">起草单位</div>
                <div class="contentDetailBoxRight mobileFont">{{detail.unit}}</div>
            </div>
            <div  class="contentDetailBox borderNone inlineBox" >
                <div class="contentDetailBoxLeft">范围</div>
                <div class="contentDetailBoxRight mobileFont">{{detail.range}}</div>
            </div>
        </div>
        <div>
  
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: 'singerDetail',
    data() {
    return {
      detail:{}

    }
  },
    mounted() {
  const id = this.$route.query.id;
      this.getDetail(id)
} ,methods: {
  getDetail(id){
         this.$API.getStandardDetail({xid:id}).then(res => {
          console.log("hhhhhhhhhhhh",res)
      if (res.code === 200) {
       this.detail = {...res.data}
      }
      console.log("2222",this.detail)
    })
    },

  },
  }
  </script>
  
  <style scoped lang='less'>
  //移动端
  @media (max-width: 768px) {
    .mobileFont{
        width: 100% !important;
        margin-top: 5px;
    }
    .inlineBox{
        display: block !important;
    }
    .contentDetailBox{
        display: flex;
        justify-content: space-between;
        padding: 20px 15px; 
        border-bottom: 1px solid #DDDDDD;
font-weight: 500;
font-size: 16px;
color: #313131;
line-height: 24px;
text-align: left;
font-style: normal;
text-transform: none;
    }
    .contentDetailBoxLeft{
        width: 35%;
    }
    .contentDetailBoxRight{
        width: 60%;
    }
    .imgView{
      display: none;
    }
    .dateBox{
font-weight: 500;
font-size: 14px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
padding-left: 16px;
padding-top: 0 !important;
    }
    .titleBox{
font-weight: 800;
font-size: 24px;
color: #313131;
line-height: 30px;
text-align: left;
font-style: normal;
text-transform: none;
padding:10px;
    }
    .contentDetail{
        padding-bottom: 20px;
font-weight: 500;
font-size: 15px;
color: #222222;
line-height: 26px;
text-align: left;
font-style: normal;
text-transform: none;
    }
    .aligCenter{
    display: flex;
    justify-content: center;
  }
    .pd25{
      padding-top: 10px;
    }
    .pcbox{
      display: none;
    }
    .contentBox{
    width: 363px;
    background: #fff;
    margin: 10px auto;
  }
    .imgView{
  width: 323px;
  height: 215px;
  margin-top:10px;
  }
  }
  //pc端
  @media (min-width: 769px) {
    .borderNone{
        border-bottom: none;
    }
    .contentDetailBox{
        display: flex;
        justify-content: space-between;
        padding: 20px 10px; 
        border-bottom: 1px solid #DDDDDD;
font-weight: 500;
font-size: 16px;
color: #313131;
line-height: 24px;
text-align: left;
font-style: normal;
text-transform: none;
    }
    .contentDetailBoxLeft{
        width: 15%;
    }
    .contentDetailBoxRight{
        width: 85%;
    }
    .dateBox{
font-weight: 500;
font-size: 16px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
    }
  .titleBox{
font-weight: 800;
font-size: 24px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
padding: 37px 0;
  }
    .mobileBox{
      display: none;
    }
    .aligCenter{
    display: flex;
    justify-content: center;
  }
  .contentDetail{
    width: 1149px;
    border:1px solid #DDDDDD;
    margin:  20px auto;
  font-weight: 500;
  font-size: 16px;
  color: #222222;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  }
  .imgView{
  width: 658px;
  height: 329px;
  }
  
  .pd25{
    padding:0 25px;
  }
  .top-list {
    width: 100%;
    min-height: calc(100vh - 200px);
    margin: 0 auto;
    background-color: #f5f5f5;
    margin-top: 10px;
  
  }
  .contentBox{
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 200px);
    background: #fff;
    padding-bottom: 80px;
  }
  }
  
  </style>